/* Copyright 2022- Martin Kufner */
Object.defineProperty(Event.prototype, 'cloneEvent', {
    value(options={}) {
        const evt = new this.constructor(this.type, this);
        for(const [prop,value] of Object.entries(options)) Reflect.defineProperty(evt, prop, {value});
        return evt;
    }
});